import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const IMAGES = {
  hero:
    "https://images.unsplash.com/photo-1716827173458-8bde30d6c78f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  a: "https://images.unsplash.com/photo-1577746838851-816a43ca8733?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  b: "https://images.unsplash.com/photo-1613730317814-1cede28e0151?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  c: "https://images.unsplash.com/photo-1527203561188-dae1bc1a417f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
};

const LifestyleEditorial = () => {
  return (
    <section className="py-24 md:py-32 border-t border-off-white/10 bg-charcoal-2 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div
          className="absolute -left-20 top-1/3 w-[600px] h-[600px] rounded-full opacity-[0.12] blur-3xl"
          style={{ background: "radial-gradient(circle, #D89999 0%, transparent 60%)" }}
        />
      </div>

      <div className="max-w-[1600px] mx-auto px-6 md:px-10 relative">
        <div className="grid md:grid-cols-12 gap-8 mb-14">
          <div className="md:col-span-6">
            <p className="font-mono text-[10px] tracking-[0.3em] text-rose mb-3">// FOR EVERY SKIN STORY</p>
            <h2 className="font-serif-display italic text-5xl md:text-7xl leading-[0.95] text-off-white">
              Made for<br />every glow.
            </h2>
          </div>
          <p className="md:col-span-5 md:col-start-8 text-off-white/70 text-lg font-light leading-relaxed self-end">
            Whip It Up is engineered for melanin-rich skin, for pale-porcelain
            skin, for every skin story in between. One ritual. Endless finishes.
          </p>
        </div>

        {/* Editorial asymmetric grid */}
        <div className="grid grid-cols-12 gap-4 md:gap-6">
          <div className="col-span-12 md:col-span-8 md:row-span-2 relative group overflow-hidden aspect-[4/3] md:aspect-auto">
            <img
              src={IMAGES.hero}
              alt="Body butter ritual"
              className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-[1.03]"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-charcoal/70 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6 md:bottom-10 md:left-10">
              <p className="font-mono text-[10px] tracking-[0.3em] text-rose mb-2">// THE RITUAL</p>
              <p className="font-serif-display italic text-2xl md:text-4xl text-off-white leading-tight max-w-md">
                “Whipped. Applied. Absorbed. Repeated — daily.”
              </p>
            </div>
          </div>

          <div className="col-span-6 md:col-span-4 aspect-square relative overflow-hidden group">
            <img src={IMAGES.a} alt="Editorial" className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-[1.05]" />
            <div className="absolute top-3 left-3 font-mono text-[10px] tracking-[0.3em] text-off-white/90">01</div>
          </div>

          <div className="col-span-6 md:col-span-4 aspect-square relative overflow-hidden group">
            <img src={IMAGES.b} alt="Editorial" className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-[1.05]" />
            <div className="absolute top-3 left-3 font-mono text-[10px] tracking-[0.3em] text-off-white/90">02</div>
          </div>

          <div className="col-span-12 md:col-span-4 aspect-[2/1] md:aspect-auto md:h-auto relative overflow-hidden group">
            <img src={IMAGES.c} alt="Editorial" className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-[1.05]" />
            <div className="absolute top-3 left-3 font-mono text-[10px] tracking-[0.3em] text-off-white/90">03</div>
          </div>

          <div className="col-span-12 md:col-span-4 border border-off-white/10 bg-off-white/[0.02] flex flex-col justify-between p-6 md:p-8">
            <div>
              <p className="font-mono text-[10px] tracking-[0.3em] text-rose">// SIGNATURE</p>
              <h3 className="font-serif-display italic text-3xl md:text-4xl text-off-white leading-tight mt-3">
                Deep tones.<br />Deeper hydration.
              </h3>
              <p className="text-off-white/65 font-light text-sm mt-4 leading-relaxed">
                Raw shea + rosehip + castor — formulated to penetrate melanin-rich skin
                without ashiness, without residue. Just glow.
              </p>
            </div>
            <Link
              to="/product/body-butter"
              className="mt-6 inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.25em] text-off-white hover:text-rose transition-colors-only kinetic-link self-start"
            >
              MEET THE BUTTER <ArrowUpRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LifestyleEditorial;
